// Shared display helpers for the Activity Log views.

const EXACT_OPTIONS = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  timeZoneName: 'short',
};

const SHORT_OPTIONS = { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' };

/** "Jul 22, 2026, 3:36 PM MDT" (viewer's local time zone). */
export const formatExact = (value) => (value ? new Date(value).toLocaleString('en-US', EXACT_OPTIONS) : '—');

/** "Sep 29, 2:37 PM" */
export const formatShort = (value) => (value ? new Date(value).toLocaleString('en-US', SHORT_OPTIONS) : '—');

/** "Sep 29, 2026" */
export const formatDate = (value) => (value
  ? new Date(value).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
  : '—');

/** "5m ago", "3h ago", "12d ago", "4mo ago". */
export const formatRelative = (value, now = Date.now()) => {
  if (!value) return '';
  const diff = Math.max(0, Math.floor((now - new Date(value).getTime()) / 1000));
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  const days = Math.floor(diff / 86400);
  if (days < 60) return `${days}d ago`;
  return `${Math.floor(days / 30)}mo ago`;
};

/** "12 min", "1 h 5 min", "under a minute". */
export const formatDuration = (from, to) => {
  if (!from || !to) return '';
  const minutes = Math.round((new Date(to).getTime() - new Date(from).getTime()) / 60000);
  if (minutes < 1) return 'under a minute';
  if (minutes < 60) return `${minutes} min`;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m ? `${h} h ${m} min` : `${h} h`;
};

const ROLE_LABELS = {
  admin: 'Admin',
  management: 'Management',
  board: 'Board',
  board_member: 'Board',
  acc_member: 'ACC',
  member: 'Member',
};

export const formatRole = (role) => {
  if (!role) return '';
  return ROLE_LABELS[role] || role.charAt(0).toUpperCase() + role.slice(1).replace(/_/g, ' ');
};

const SECTION_LABELS = {
  dashboard: 'Dashboard',
  documents: 'Library',
  messages: 'Inbox',
  directory: 'Directory',
  events: 'Events',
  profile: 'Profile',
  payments: 'Payments',
  accReview: 'ACC Review',
  users: 'Users',
  members: 'Members',
  activity: 'Activity Log',
  settings: 'Settings',
  'insight-digest': 'Insight Digest',
};

export const formatSection = (section) => SECTION_LABELS[section] || section || '';

export const plural = (count, word, pluralWord) => `${count} ${count === 1 ? word : (pluralWord || `${word}s`)}`;
